import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import MdmModel from './MdmModel';

const {routes} = router.options;
const route = routes.find(r => r.path === '/app');

const tmpRoutes = [
  {
    path: 'mdm-model',
    name: 'MdmModel',
    component: MdmModel,
    meta: {
      requiresAuth: true,
    },
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('MdmModel', {
//   path: '/app/mdm-model',
//   text: 'MDM Model',
//   uuid: 'MDM Model',
//   permission: 'read',
//   weight: 0,
//   icon: ['fas', 'project-diagram']
// }));
